import {eventUrl} from './base';
import {myAxios} from "../util/myAxios";
import type {Prize} from "../entities/Prize";

export function getPrizes(
  dayId: string
): Promise<Prize[]> {
  return myAxios()
    .then(axios => axios.get(eventUrl(`/days/${dayId}/contest/prizes`)))
    .then(response => response.data)
}


